import { Box } from "@chakra-ui/react";

import { Dataset } from "@nens/rana/api-v1";
import { getWmsRequest } from "@nens/react-map-gl/utils";

import { RanaMap } from "@/lib/rana-map";
import { useDatasetWmsLinkQuery } from "@/queries/query-dataset-wms-links";

interface DatasetDetailMapProps {
  dataset: Dataset;
}
export const DatasetDetailMap = ({ dataset }: DatasetDetailMapProps) => {
  const { envelope } = dataset;
  const { data: wmsLinks, isLoading } = useDatasetWmsLinkQuery(dataset.id);

  // Create an array of tile URLs for all WMS links and their layers
  const tilesArray = (wmsLinks ?? []).flatMap(({ url, layers }) =>
    layers.map(({ id }) =>
      getWmsRequest(url.split("?")[0], {
        layer: id + "",
        transparent: true,
      })
    )
  );

  const bounds = envelope ? (envelope[0] as [number, number, number, number]) : undefined;

  return (
    <Box h="md" rounded="base" overflow="hidden" borderWidth="base">
      <RanaMap isLoading={isLoading} mapId="dataset-map" bounds={bounds} mapProps={{}}>
        <RanaMap.MapScale />
        {(() => {
          if (isLoading) return null;

          if (tilesArray.length === 0) {
            return <RanaMap.ExtentLayer bounds={bounds} />;
          }

          return tilesArray.map((tiles) => (
            <RanaMap.Source bounds={bounds} key={tiles} type="raster" tiles={[tiles]}>
              <RanaMap.Layer id={tiles} type="raster" />
            </RanaMap.Source>
          ));
        })()}
      </RanaMap>
    </Box>
  );
};
